import { createContext, useContext } from 'react'
import type { AirgapAPI, TranscendAPI } from '@transcend-io/airgap.js-types'

interface ConsentAPI {
  airgap?: AirgapAPI
  transcend?: TranscendAPI
}

export const ConsentContext = createContext<ConsentAPI>({})

export const useConsentManager = (): ConsentAPI => useContext(ConsentContext)
